import React from 'react';
import { Box } from '@mui/material';
import { BoxProps } from '@mui/material/Box/Box';

export const FlexBox = (props: BoxProps) => {
  return <Box {...props} display={'flex'} />;
};
